export default {
	title: "Groups",
	newGroup: "New Group",
	editGroup: "Edit Group",
	deleteGroup: "Delete Group",
	name: "Name",
	description: "Description",
	color: "Color",
	icon: "Icon",
	members: "Members",
	calendar: "Calendar",
	assignments: "Activities",
	addMember: "Add Member",
	removeMember: "Remove Member",
	removeMemberConfirm: "Are you sure you want to remove this member from the group?",
	deleteConfirm: "Are you sure you want to delete the group \"{name}\"? All members will be unlinked and all activities and reminders will be removed. This action cannot be undone.",
	noMembers: "No members in this group",
	noMembersText: "Add members to organize your group",
	noAssignments: "No activities scheduled",
	noAssignmentsText: "Add an activity using the Calendar",
	selectDayHint: "Select a day to view or add an activity",
	emptyTitle: "No groups registered",
	emptyText: "Create groups to organize your temple's members",
	searchPlaceholder: "Search groups...",
	status: {
		active: "Active",
		inactive: "Inactive",
	},
	filters: {
		status: "Status",
		active: "Active",
		inactive: "Inactive",
	},
	assignment: {
		new: "New Activity",
		edit: "Edit Activity",
		delete: "Delete Activity",
		deleteConfirm: "Are you sure you want to delete this activity?",
		date: "Date",
		startTime: "Time",
		description: "Description",
		linkRitual: "Link to ritual",
		selectRitual: "Select ritual",
		reminder: "Send email reminder",
		reminderDays: "Days before",
		reminderHintSameDay: "On the day of the activity",
		reminderHint1Day: "1 day before",
		reminderHintDays: "{days} days before",
		reminderMessage: "Custom message",
		reminderMessageHint: "Leave blank to use the default template",
		addToDay: "Add activity",
		batchMode: "Multiple days",
		batchDatesSelected: "{count} date(s) selected",
		linkFirstRitual: "Link to first ritual of each day, if available",
	},
	messages: {
		created: "Group created successfully",
		updated: "Group updated successfully",
		deleted: "Group deleted successfully",
		memberAdded: "Member added successfully",
		memberRemoved: "Member removed successfully",
		assignmentCreated: "Activity created successfully",
		assignmentUpdated: "Activity updated successfully",
		assignmentDeleted: "Activity deleted successfully",
		errorLoading: "Error loading data",
	},
	stats: {
		total: "Total",
		active: "Active",
		totalMembers: "Members",
	},
	validation: {
		nameRequired: "Group name is required",
		nameMaxLength: "Name must be at most 150 characters",
	},
	activities: {
		tab: "Activities",
		upcoming: "Upcoming",
		past: "Past",
		all: "All",
		linkedToRitual: "Linked to ritual",
		noActivities: "No activities found",
		noActivitiesUpcoming: "No upcoming activities scheduled",
		noActivitiesPast: "No past activities recorded",
		showMore: "Load more",
	},
	weekDays: {
		sun: "Sun",
		mon: "Mon",
		tue: "Tue",
		wed: "Wed",
		thu: "Thu",
		fri: "Fri",
		sat: "Sat",
	},
};
